<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div class="title">Convidar</div>
        <div @click="$router.push('/invitation')" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form @submit.prevent class="form">
        <!-- Emails -->
        <label>E-mails</label>
        <textarea v-model="emails" rows="5" placeholder="E-mails separados por enter" :class="{ error : error.indexOf('emails') > -1 }" />
        <div v-if="error.indexOf('emails') > -1" class="hint">você informou os e-mails incorretamente</div>
        <label>Espetáculo</label>
        <Autocomplete :model="setShow" :list="showOptions" doNotSort="true" placeholder="Selecione" :class="{ error : error.indexOf('show') > -1 }" />
        <div v-if="error.indexOf('show') > -1" class="hint">Espetáculo inválido</div>
        <!-- Setores -->
        <template v-if="sections.length > 1">
          <label>Setores</label>
          <div style="display: flex; justify-content: space-between; align-items: center">
            <label class="switch" style="margin: 0; margin-right: 20px">
              <input v-model="allSections" type="checkbox">
              <span class="slider"></span>
              <span class="text">TODOS</span>
            </label>
            <Select v-if="!allSections" v-model="sectionsSelected" multiple="true" :options="sectionOptions" />
          </div>
        </template>
        <!-- Desconto -->
        <label>Cupom</label>
        <div class="form-search" style="display: flex; justify-content: space-between; align-items: center">
          <select :disabled="!show" v-model="type" :change="setFormat()" style="width: 180px">
            <option value="percent">Desconto percentual</option>
            <option value="value">Desconto por valor</option>
            <option value="fixed">Valor fixo</option>
          </select>
          <div style="flex-basis: 45%">
            <!--<input :disabled="!show" v-model="discount" type="number" placeholder="Valor" :class="{ error : error.indexOf('discount') > -1 }" style="width:130px;float:right;"/>-->
            <money :disabled="!show" v-bind="formatMoney" v-model="discount" :class="{ error : error.indexOf('discount') > -1 }" style="width:130px;float:right;"></money>
          </div>
        </div>
        <!--<div style="display: flex; justify-content: space-between; align-items: center">
          <Selector class="custom-selector" v-model="type" :options="types" style="flex-basis: 45%;background-color: #cccccc;color: #595959;font-size: 0.8em;padding: 2.5px;max-width: 300px;" />
          <div style="flex-basis: 45%">
            <div v-show="type === 'value'" style="float:left;font-size:20px;margin-top:5px;margin-right:5px;">R$</div>
            <input :disabled="!show" v-model="discount" type="number" placeholder="Valor" :class="{ error : error.indexOf('discount') > -1 }" style="width:130px;float:left;"/>
            <div v-show="type === 'percent'" style="float:left;font-size:20px;margin-top:5px;margin-left:5px;">%</div>
          </div>
        </div>-->
        <div v-if="error.indexOf('discount') > -1" class="hint">você esqueceu de digitar o valor do desconto</div>
        <div style="margin-top:5px;font-size:10px;" v-if="price && type === 'value' || type === 'percent'">O desconto concedido é baseado no ingresso de maior valor ofertado no setor/lote em questão<div v-if="sections.length > 0" style="display:inline;">.</div><div v-if="sections.length === 0" style="display:inline;">, no caso o ingresso de valor R$ {{price.toLocaleString('pt-br', { minimumFractionDigits: 2 })}}.</div></div>
        <!-- Validade -->
        <label>Validade</label>
        <input :disabled="!show" v-model="expiration" v-on:keydown="validade" type="date" :min="(new Date()).toISOString().split('T')[0]" :max="maxDate" :class="{ error : error.indexOf('expiration') > -1 }"/>
        <div v-if="error.indexOf('expiration') > -1" class="hint">Validade inválida</div>
        <div class="actions" style="padding: 30px 0 20px">
          <button @click="invite" class="button-save" style="width: 100%">
            <i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i>
            <span>Confirmar</span>
          </button>
        </div>
      </form>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import Autocomplete from './Autocomplete'
import Select from './Select'
import { getShows, create } from '../api/invitation'

export default {
  name: 'invitation',
  components: { Autocomplete, Select },
  props: ['id'],
  data () {
    return {
      loading: false,
      error: [],
      emails: null,
      show: null,
      sections: [],
      prices: [],
      type: 'value',
      discount: '',
      expiration: null,
      shows: [],
      types: [
        { value: 'percent', text: 'PERCENTUAL' },
        { value: 'value', text: 'VALOR' }
      ],
      showDate: null,
      maxDate: null,
      sectionsSelected: [],
      allSections: true,
      price: null,
      formatMoney: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    showOptions () {
      return this.shows.map(x => `${x.name} | ${x.date}`)
    },
    sectionOptions () {
      return this.sections.map(x => ({ value: x, text: x }))
    }
  },
  async mounted () {
    try {
      const shows = await getShows()
      this.shows = shows
    } catch (error) {
      logger.error(error, this)
    }
  },
  watch: {
    async show (show) {
      if (show) {
        const selected = this.shows.find(x => x.name === show.split('|')[0].trim() && x.date === show.split('|')[1].trim())
        this.showDate = selected.id
        this.expiration = selected.dateIso
        this.sections = selected.sections
        this.prices = selected.prices
        this.sectionsSelected = selected.sections
        this.maxDate = selected.dateIso
        this.allSections = true
        if (selected.sections.length === 0) {
          this.price = selected.prices[0]
        }
      }
    }
  },
  methods: {
    validade (e) {
      e.preventDefault()
    },
    setFormat () {
      if (this.type === 'percent') {
        this.formatMoney.decimal = ''
        this.formatMoney.thousands = ''
        this.formatMoney.prefix = ''
        this.formatMoney.suffix = ' %'
        this.formatMoney.precision = 0
      } else {
        this.formatMoney.decimal = ','
        this.formatMoney.thousands = '.'
        this.formatMoney.prefix = 'R$ '
        this.formatMoney.suffix = ''
        this.formatMoney.precision = 2
      }
    },
    setShow (show = null) {
      if (show) {
        this.show = show
      } else {
        return this.show
      }
    },
    async invite () {
      try {
        if (this.loading) return false
        if (this.type === 'percent' && Number(this.discount) > 100) {
          this.$message.error('O desconto percentual não pode ser maior que 100')
          return false
        } else if (this.sections.length === 0 && this.type === 'value' && Number(this.discount) > Number(this.price)) {
          this.$message.error('O valor do desconto não pode ser maior que R$ ' + this.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }), { duration: 3000 })
          return false
        } else {
          for (let i = 0; i < this.sections.length; i++) {
            if (this.type === 'value' && Number(this.discount) > Number(this.prices[i])) {
              this.$message.error('O valor do convite de desconto não pode ser maior que o ingresso de maior valor do setor ' + this.sections[i], { duration: 3000 })
              return false
            }
          }
        }
        this.loading = true
        this.error = []
        await create(
          this.showDate,
          this.type,
          this.discount,
          `${this.expiration} 23:59:59`,
          this.sections.length <= 1 || this.allSections ? this.sections : this.sectionsSelected,
          this.emails.split('\n').map(x => String(x).toLowerCase())
        )
        this.loading = false
        this.$router.push('/invitation')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
input[type="date"] {
        position: relative;
    }

    /* create a new arrow, because we are going to mess up the native one
    see "List of symbols" below if you want another, you could also try to add a font-awesome icon.. */
    input[type="date"]:after {
        content: "\25BC";
        color: #555;
        padding: 0 5px;
    }

    /* change color of symbol on hover */
    input[type="date"]:hover:after {
        color: #555;
    }

    /* make the native arrow invisible and stretch it over the whole field so you can click anywhere in the input field to trigger the native datepicker*/
    input[type="date"]::-webkit-calendar-picker-indicator {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        width: auto;
        height: auto;
        color: transparent;
        background: transparent;
        cursor: pointer;
    }

    /* adjust increase/decrease button */
    input[type="date"]::-webkit-inner-spin-button {
        z-index: 1;
    }

    /* adjust clear button */
    input[type="date"]::-webkit-clear-button {
        z-index: 1;
    }
</style>
